export default __webpack_public_path__ + "static/media/Revisão.d214df5c.svg";